import { createContext, useContext } from 'react';

// Whether the enclosing dockview panel is the visible / active tab.
// dockview keeps background-tab panels mounted (so their state survives a
// tab switch) but hidden; this context lets a panel cheaply react to that
// so it can defer expensive work (e.g. the Map's heavy facilities fetch)
// until it's actually on screen.
//
// Defaults to true so a panel rendered outside the dockview wrapper (tests,
// storybook, the help tab) behaves as visible.
export const PanelVisibilityContext = createContext<boolean>(true);

/** True when the enclosing dockview panel is the active/visible tab. */
export function usePanelVisible(): boolean {
  return useContext(PanelVisibilityContext);
}
